import React from "react";
import Webcam from "react-webcam";

const WebcamCapture = () => {
  const [selectedDeviceId, setSelectedDeviceId] = React.useState(null);

  const handleDevices = React.useCallback(mediaDevices => {
    const videoInputs = mediaDevices.filter(device => device.kind === "videoinput");

    // Try to pick the Samsung "camera2 0, facing back" if available
    const samsungBackCam = videoInputs.find(
      device => device.label.toLowerCase().includes("0")
    );

    // If on Samsung and we found the preferred back cam, use that
    if (samsungBackCam) {
      setSelectedDeviceId(samsungBackCam.deviceId);
    } else {
      // Otherwise, fallback to any "facing back" cam
      const genericBackCam = videoInputs.find(device =>
        device.label.toLowerCase().includes("facing back")
      );
      setSelectedDeviceId( null);
    }
  }, []);

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  return (
    <div>
      {selectedDeviceId && (
        <Webcam
          audio={false}
          videoConstraints={{ deviceId: selectedDeviceId,facingMode:"environment" }}
          style={{ width: "100%", height: "auto" }}
        />
      )}
    </div>
  );
};

export default WebcamCapture;
